/**
 * NotFound — global 404 component, wired as `defaultNotFoundComponent` on the
 * router (see `apps/web/src/main.tsx`).
 *
 * Standards: render 404 status semantics, give the user a way back home and a
 * way back through history, and avoid blaming the user. Copy stays in V1
 * English-only per system-decisions §6.
 */
import { Link, useRouter } from "@tanstack/react-router";
import { Button } from "@flint/ui";
import { ErrorScreen } from "./error-screen.js";

export function NotFound() {
  const router = useRouter();

  return (
    <ErrorScreen
      status={404}
      kicker="Page not found"
      tone="warn"
      title="We couldn't find that page."
      description="The link may be stale, or the page may have moved. From here you can head back to the workspace, or return to where you were."
      actions={
        <>
          <Button asChild intent="primary">
            <Link to="/">Back to workspace</Link>
          </Button>
          <Button type="button" intent="ghost" onClick={() => router.history.back()}>
            Go back
          </Button>
        </>
      }
    />
  );
}
